export default {
  on: function (name, callback, priority = 10, ctx) {
    let e = this.e || (this.e = {})
    e[name] = e[name] || []
    e[name].push({
      fn: callback,
      priority,
      ctx: ctx
    })

    return this
  },

  once: function (name, callback, priority = 10, ctx) {
    let self = this
    function listener() {
      self.off(name, listener)
      callback.apply(ctx, arguments)
    }

    listener._ = callback
    return this.on(name, listener, priority, ctx)
  },

  emit: function (name) {
    let data = [].slice.call(arguments, 1)
    let evtArr = ((this.e || (this.e = {}))[name] || []).slice()
    let i = 0
    let len = evtArr.length
    evtArr.sort((a, b) => a.priority - b.priority)
    for (i; i < len; i++) {
      if (evtArr[i].fn.apply(evtArr[i].ctx, data) === false) {
        break
      }
    }

    return this
  },

  off: function (name, callback) {
    let e = this.e || (this.e = {})
    let evts = e[name]
    let liveEvents = []

    if (evts && callback) {
      for (let i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback) {
          liveEvents.push(evts[i])
        }
      }
    }

    liveEvents.length ? (e[name] = liveEvents) : delete e[name]

    return this
  }
}
